/**
 * Data object representing the customer segments list item
 * @note This is usually used in data table as a row. Params don't have default values since this data object is used to
 * represent data that actually exists.
 */
export class CustomerSegmentsListItemDataObject {
	/**
	 * @param {string} id - Customer segment's DB ID.
	 * @param {string} name - Customer segment's name.
	 */
	constructor(id, name) {
		this.id = id;
		this.name = name;
	}
}

/**
 * Data object representing the customer segments item
 * @note This is usually used when creating or updating data table item using a popup or a dialog. Params have default 
 * values since this data object can be used for creating an item. This is why 'id' has a default value of null which 
 * represents a new item that is being created.
 */
export class CustomerSegmentsItemDataObject {
	/**
	 * @param {string|null} [id=null] - Customer segment's DB ID.
	 * @param {string} [name=''] - Customer segment's name.
	 * @param {string[]} [projectIds=[]] - List of DB IDs of projects where the customer segment can be used.
	 * @param {ConditionListItemDataObject[]} [conditions=[]] - Customer segment's conditions.
	 */
	constructor(id = null, name = '', projectIds = [], conditions = []) {
		this.id = id;
		this.name = name;
		this.projectIds = projectIds;
		this.conditions = conditions;
	}
}